import { render, staticRenderFns } from "./MyDocumentDetailsMobile.vue?vue&type=template&id=5c85d9f6&scoped=true&"
import script from "./MyDocumentDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./MyDocumentDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./MyDocumentDetailsMobile.vue?vue&type=style&index=0&id=5c85d9f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85d9f6",
  null
  
)

export default component.exports